import React, { Component } from 'react';
import { getPayments } from '../services/bitcoinPaymentService';
import Spinner from './common/spinner';
import BuyBitcoinsTable from './buyBitcoinsTable';

class BuyBitcoins extends Component {
  state = {
    payments: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const result = await getPayments();
    this.setState({ loading: false });
    const { data: payments } = result.data;
    this.setState({ payments });
  }

  getPagedData = () => {
    const { payments } = this.state;

    return { data: payments };
  };

  render() {
    const { data: payments } = this.getPagedData();
    const { loading } = this.state;
    if (loading) return <Spinner message="loading page data..." />;
    return (
      <React.Fragment>
        <BuyBitcoinsTable
          payments={payments}
          message="Bitcoin Purchase Transactions"
        />
      </React.Fragment>
    );
  }
}

export default BuyBitcoins;
